// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"74df372e","513":"2344e8ca","703":"72009d73"}[chunkId] + ".chunk.js";
};